import React from 'react';

const AnomalyAnalysisPage = () => {
    return <div />;
};

export default AnomalyAnalysisPage;
